import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
  container: {
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    boxShadow: `0 3px 6px ${theme.palette.grey[500]}`,
    rowGap: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      rowGap: theme.spacing(1),
    },
  },
  propertyColumn: {
    minWidth: 0,
  },
  propertyList: {
    minWidth: 0,
    width: '100%',
    '& > .MuiGrid-item': {
      minWidth: 0,
      maxWidth: '100%',
      width: '100%',
    },
    '& > * + *': {
      marginTop: theme.spacing(0.5 / 3),
    },
  },
  amountColumn: {
    minWidth: theme.spacing(16),
    '& .MuiGrid-container': { alignItems: 'flex-end' },
    '& + &': {
      paddingLeft: theme.spacing(2),
    },
    [theme.breakpoints.down('md')]: {
      minWidth: 0,
      '& + &': {
        paddingLeft: 0,
      },
    },
  },
  action: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginLeft: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  icon: { color: theme.palette.text.primary },
  propertyButton: {
    justifyContent: 'flex-start',
    padding: 0,
    textAlign: 'left',
    '&:hover': { backgroundColor: theme.palette.button.hover },
    [theme.breakpoints.down('md')]: {
      display: 'block',
      boxSizing: 'border-box',
      maxWidth: '100%',
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: '100%',
      '& .MuiTypography-root': {
        display: 'block',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
    },
  },
  propertyButtonSelected: {
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
}));
